import { GET_OFFER_STATE_HISTORY } from "helpers/url_helper"
import {
  GET_CURATOR_OFFERS,
  GET_CURATOR_OFFERS_SUCCESS,
  GET_CURATOR_OFFERS_FAIL,
  CLEAR_CURATOR_OFFERS,
  GET_OPERATION_OFFERS,
  GET_OPERATION_OFFERS_SUCCESS,
  GET_OPERATION_OFFERS_FAIL,
  CLEAR_OPERATION_OFFERS,
  GET_APPROVER_OFFERS,
  GET_APPROVER_OFFERS_SUCCESS,
  GET_APPROVER_OFFERS_FAIL,
  CLEAR_APPROVER_OFFERS,
  GET_PUBLISHED_OFFERS,
  GET_PUBLISHED_OFFERS_SUCCESS,
  GET_PUBLISHED_OFFERS_FAIL,
  CLEAR_PUBLISHED_OFFERS,
  MANAGE_CURATOR_OFFER,
  MANAGE_CURATOR_OFFER_SUCCESS,
  MANAGE_CURATOR_OFFER_FAIL,
  MANAGE_OPERATION_OFFER,
  MANAGE_OPERATION_OFFER_SUCCESS,
  MANAGE_OPERATION_OFFER_FAIL,
  MANAGE_PUBLISHED_OFFER,
  MANAGE_PUBLISHED_OFFER_SUCCESS,
  MANAGE_PUBLISHED_OFFER_FAIL,
  GET_OFFER_TAGS,
  GET_OFFER_TAGS_SUCCESS,
  GET_OFFER_TAGS_FAIL,
  MANAGE_OFFER_TAG,
  MANAGE_OFFER_TAG_SUCCESS,
  MANAGE_OFFER_TAG_FAIL,
  CLEAR_OFFER_TAGS,
  GET_OFFER_TAG_DEFINITIONS,
  GET_OFFER_TAG_DEFINITIONS_SUCCESS,
  GET_OFFER_TAG_DEFINITIONS_FAIL,
  CLEAR_OFFER_TAG_DEFINITIONS,
  GET_OFFER_INCLUSIONS,
  GET_OFFER_INCLUSIONS_SUCCESS,
  GET_OFFER_INCLUSIONS_FAIL,
  MANAGE_OFFER_INCLUSIONS,
  MANAGE_OFFER_INCLUSIONS_SUCCESS,
  MANAGE_OFFER_INCLUSIONS_FAIL,
  CLEAR_OFFER_INCLUSIONS,
  GET_OFFER_EXCLUSIONS,
  GET_OFFER_EXCLUSIONS_SUCCESS,
  GET_OFFER_EXCLUSIONS_FAIL,
  MANAGE_OFFER_EXCLUSIONS,
  MANAGE_OFFER_EXCLUSIONS_SUCCESS,
  MANAGE_OFFER_EXCLUSIONS_FAIL,
  CLEAR_OFFER_EXCLUSIONS,
  GET_OFFER_TERMS_CONDITIONS,
  GET_OFFER_TERMS_CONDITIONS_SUCCESS,
  GET_OFFER_TERMS_CONDITIONS_FAIL,
  MANAGE_OFFER_TERMS_CONDITIONS,
  MANAGE_OFFER_TERMS_CONDITIONS_SUCCESS,
  MANAGE_OFFER_TERMS_CONDITIONS_FAIL,
  CLEAR_OFFER_TERMS_CONDITIONS,
  CLEAR_OFFER_INCLUSIONS_SUCCESS,
  CLEAR_OFFER_EXCLUSIONS_SUCCESS,
  CLEAR_OFFER_TERMS_CONDITIONS_SUCCESS,
  ADD_INCLUSION_TO_FORM,
  UPDATE_INCLUSION_IN_FORM,
  REMOVE_INCLUSION_FROM_FORM,
  CLEAR_INCLUSION_FORM,
  ADD_EXCLUSION_TO_FORM,
  UPDATE_EXCLUSION_IN_FORM,
  REMOVE_EXCLUSION_FROM_FORM,
  CLEAR_EXCLUSION_FORM,
  ADD_TERM_TO_FORM,
  UPDATE_TERM_IN_FORM,
  REMOVE_TERM_FROM_FORM,
  CLEAR_TERM_FORM,
  GET_OFFER_STATE_HISTORY_SUCCESS,
  GET_OFFER_STATE_HISTORY_FAIL,
  CLEAR_OFFER_STATE_HISTORY,
  POST_OFFER,
  POST_OFFER_SUCCESS,
  POST_OFFER_FAIL,
  REJECT_OFFER,
  REJECT_OFFER_SUCCESS,
  REJECT_OFFER_FAIL,
  PROCESS_OFFER,
  PROCESS_OFFER_SUCCESS,
  PROCESS_OFFER_FAIL,
  PUBLISH_OFFER,
  PUBLISH_OFFER_SUCCESS,
  PUBLISH_OFFER_FAIL,
  DENY_OFFER,
  DENY_OFFER_SUCCESS,
  DENY_OFFER_FAIL,
} from "./actionTypes"

// CURATOR OFFERS ACTIONS
export const getCuratorOffers = (options, history) => ({
  type: GET_CURATOR_OFFERS,
  payload: { options, history },
})

export const getCuratorOffersSuccess = offers => ({
  type: GET_CURATOR_OFFERS_SUCCESS,
  payload: offers,
})

export const getCuratorOffersFail = error => ({
  type: GET_CURATOR_OFFERS_FAIL,
  payload: error,
})

export const clearCuratorOffers = () => ({
  type: CLEAR_CURATOR_OFFERS,
})

// OPERATION OFFERS ACTIONS
export const getOperationOffers = (options, history) => ({
  type: GET_OPERATION_OFFERS,
  payload: { options, history },
})

export const getOperationOffersSuccess = offers => ({
  type: GET_OPERATION_OFFERS_SUCCESS,
  payload: offers,
})

export const getOperationOffersFail = error => ({
  type: GET_OPERATION_OFFERS_FAIL,
  payload: error,
})

export const clearOperationOffers = () => ({
  type: CLEAR_OPERATION_OFFERS,
})

// APPROVER OFFERS ACTIONS
export const getApproverOffers = (options, history) => ({
  type: GET_APPROVER_OFFERS,
  payload: { options, history },
})

export const getApproverOffersSuccess = offers => ({
  type: GET_APPROVER_OFFERS_SUCCESS,
  payload: offers,
})

export const getApproverOffersFail = error => ({
  type: GET_APPROVER_OFFERS_FAIL,
  payload: error,
})

export const clearApproverOffers = () => ({
  type: CLEAR_APPROVER_OFFERS,
})

// PUBLISHED OFFERS ACTIONS
export const getPublishedOffers = (options, history) => ({
  type: GET_PUBLISHED_OFFERS,
  payload: { options, history },
})

export const getPublishedOffersSuccess = offers => ({
  type: GET_PUBLISHED_OFFERS_SUCCESS,
  payload: offers,
})

export const getPublishedOffersFail = error => ({
  type: GET_PUBLISHED_OFFERS_FAIL,
  payload: error,
})

export const clearPublishedOffers = () => ({
  type: CLEAR_PUBLISHED_OFFERS,
})

// MANAGE CURATOR OFFER ACTIONS
export const manageCuratorOffer = (offer, history) => ({
  type: MANAGE_CURATOR_OFFER,
  payload: { offer, history },
})

export const manageCuratorOfferSuccess = offer => ({
  type: MANAGE_CURATOR_OFFER_SUCCESS,
  payload: offer,
})

export const manageCuratorOfferFail = error => ({
  type: MANAGE_CURATOR_OFFER_FAIL,
  payload: error,
})

// MANAGE OPERATION OFFER ACTIONS
export const manageOperationOffer = (offer, history) => ({
  type: MANAGE_OPERATION_OFFER,
  payload: { offer, history },
})

export const manageOperationOfferSuccess = offer => ({
  type: MANAGE_OPERATION_OFFER_SUCCESS,
  payload: offer,
})

export const manageOperationOfferFail = error => ({
  type: MANAGE_OPERATION_OFFER_FAIL,
  payload: error,
})

// MANAGE PUBLISHED OFFER ACTIONS
export const managePublishedOffer = (offer, history) => ({
  type: MANAGE_PUBLISHED_OFFER,
  payload: { offer, history },
})

export const managePublishedOfferSuccess = offer => ({
  type: MANAGE_PUBLISHED_OFFER_SUCCESS,
  payload: offer,
})

export const managePublishedOfferFail = error => ({
  type: MANAGE_PUBLISHED_OFFER_FAIL,
  payload: error,
})

// OFFER TAGS ACTIONS
export const getOfferTags = (options, history) => ({
  type: GET_OFFER_TAGS,
  payload: { options, history },
})

export const getOfferTagsSuccess = tags => ({
  type: GET_OFFER_TAGS_SUCCESS,
  payload: tags,
})

export const getOfferTagsFail = error => ({
  type: GET_OFFER_TAGS_FAIL,
  payload: error,
})

export const manageOfferTags = (data, history) => ({
  type: MANAGE_OFFER_TAG,
  payload: { data, history },
})

export const manageOfferTagsSuccess = response => ({
  type: MANAGE_OFFER_TAG_SUCCESS,
  payload: response,
})

export const manageOfferTagsFail = error => ({
  type: MANAGE_OFFER_TAG_FAIL,
  payload: error,
})

export const clearOfferTags = () => ({
  type: CLEAR_OFFER_TAGS,
})

// OFFER TAG DEFINITIONS ACTIONS
export const getOfferTagDefinitions = (options, history) => ({
  type: GET_OFFER_TAG_DEFINITIONS,
  payload: { options, history },
})

export const getOfferTagDefinitionsSuccess = definitions => ({
  type: GET_OFFER_TAG_DEFINITIONS_SUCCESS,
  payload: definitions,
})

export const getOfferTagDefinitionsFail = error => ({
  type: GET_OFFER_TAG_DEFINITIONS_FAIL,
  payload: error,
})

export const clearOfferTagDefinitions = () => ({
  type: CLEAR_OFFER_TAG_DEFINITIONS,
})

// OFFER INCLUSIONS ACTIONS
export const getOfferInclusions = (options, history) => ({
  type: GET_OFFER_INCLUSIONS,
  payload: { options, history },
})

export const getOfferInclusionsSuccess = inclusions => ({
  type: GET_OFFER_INCLUSIONS_SUCCESS,
  payload: inclusions,
})

export const getOfferInclusionsFail = error => ({
  type: GET_OFFER_INCLUSIONS_FAIL,
  payload: error,
})

export const manageOfferInclusions = (inclusions, history) => ({
  type: MANAGE_OFFER_INCLUSIONS,
  payload: { inclusions, history },
})

export const manageOfferInclusionsSuccess = inclusions => ({
  type: MANAGE_OFFER_INCLUSIONS_SUCCESS,
  payload: inclusions,
})

export const manageOfferInclusionsFail = error => ({
  type: MANAGE_OFFER_INCLUSIONS_FAIL,
  payload: error,
})

export const clearOfferInclusions = () => ({
  type: CLEAR_OFFER_INCLUSIONS,
})

// OFFER EXCLUSIONS ACTIONS
export const getOfferExclusions = (options, history) => ({
  type: GET_OFFER_EXCLUSIONS,
  payload: { options, history },
})

export const getOfferExclusionsSuccess = exclusions => ({
  type: GET_OFFER_EXCLUSIONS_SUCCESS,
  payload: exclusions,
})

export const getOfferExclusionsFail = error => ({
  type: GET_OFFER_EXCLUSIONS_FAIL,
  payload: error,
})

export const manageOfferExclusions = (exclusions, history) => ({
  type: MANAGE_OFFER_EXCLUSIONS,
  payload: { exclusions, history },
})

export const manageOfferExclusionsSuccess = exclusions => ({
  type: MANAGE_OFFER_EXCLUSIONS_SUCCESS,
  payload: exclusions,
})

export const manageOfferExclusionsFail = error => ({
  type: MANAGE_OFFER_EXCLUSIONS_FAIL,
  payload: error,
})

export const clearOfferExclusions = () => ({
  type: CLEAR_OFFER_EXCLUSIONS,
})

// OFFER TERMS & CONDITIONS ACTIONS
export const getOfferTermsConditions = (options, history) => ({
  type: GET_OFFER_TERMS_CONDITIONS,
  payload: { options, history },
})

export const getOfferTermsConditionsSuccess = termsConditions => ({
  type: GET_OFFER_TERMS_CONDITIONS_SUCCESS,
  payload: termsConditions,
})

export const getOfferTermsConditionsFail = error => ({
  type: GET_OFFER_TERMS_CONDITIONS_FAIL,
  payload: error,
})

export const manageOfferTermsConditions = (termsConditions, history) => ({
  type: MANAGE_OFFER_TERMS_CONDITIONS,
  payload: { termsConditions, history },
})

export const manageOfferTermsConditionsSuccess = termsConditions => ({
  type: MANAGE_OFFER_TERMS_CONDITIONS_SUCCESS,
  payload: termsConditions,
})

export const manageOfferTermsConditionsFail = error => ({
  type: MANAGE_OFFER_TERMS_CONDITIONS_FAIL,
  payload: error,
})

export const clearOfferTermsConditions = () => ({
  type: CLEAR_OFFER_TERMS_CONDITIONS,
})

export const clearOfferInclusionsSuccess = () => ({
  type: CLEAR_OFFER_INCLUSIONS_SUCCESS,
})

export const clearOfferExclusionsSuccess = () => ({
  type: CLEAR_OFFER_EXCLUSIONS_SUCCESS,
})

export const clearOfferTermsConditionsSuccess = () => ({
  type: CLEAR_OFFER_TERMS_CONDITIONS_SUCCESS,
})

// INCLUSION FORM MANAGEMENT ACTIONS
export const addInclusionToForm = (inclusion) => ({
  type: ADD_INCLUSION_TO_FORM,
  payload: inclusion,
})

export const updateInclusionInForm = (index, inclusion) => ({
  type: UPDATE_INCLUSION_IN_FORM,
  payload: { index, inclusion },
})

export const removeInclusionFromForm = (index) => ({
  type: REMOVE_INCLUSION_FROM_FORM,
  payload: index,
})

export const clearInclusionForm = () => ({
  type: CLEAR_INCLUSION_FORM,
})

// EXCLUSION FORM MANAGEMENT ACTIONS
export const addExclusionToForm = (exclusion) => ({
  type: ADD_EXCLUSION_TO_FORM,
  payload: exclusion,
})

export const updateExclusionInForm = (index, exclusion) => ({
  type: UPDATE_EXCLUSION_IN_FORM,
  payload: { index, exclusion },
})

export const removeExclusionFromForm = (index) => ({
  type: REMOVE_EXCLUSION_FROM_FORM,
  payload: index,
})

export const clearExclusionForm = () => ({
  type: CLEAR_EXCLUSION_FORM,
})

// TERM FORM MANAGEMENT ACTIONS
export const addTermToForm = (term) => ({
  type: ADD_TERM_TO_FORM,
  payload: term,
})

export const updateTermInForm = (index, term) => ({
  type: UPDATE_TERM_IN_FORM,
  payload: { index, term },
})

export const removeTermFromForm = (index) => ({
  type: REMOVE_TERM_FROM_FORM,
  payload: index,
})

export const clearTermForm = () => ({
  type: CLEAR_TERM_FORM,
})

// OFFER STATE HISTORY ACTIONS

export const getOfferStateHistory = (options, history) => ({
  type: GET_OFFER_STATE_HISTORY,
  payload: { options, history },
})

export const getOfferStateHistorySuccess = history => ({
  type: GET_OFFER_STATE_HISTORY_SUCCESS,
  payload: history,
})

export const getOfferStateHistoryFail = error => ({
  type: GET_OFFER_STATE_HISTORY_FAIL,
  payload: error,
})

export const clearOfferStateHistory = () => ({
  type: CLEAR_OFFER_STATE_HISTORY,
})

// OFFER ACTIONS

export const postOffer = (payload, history) => ({
  type: POST_OFFER,
  payload: { payload, history },
})

export const postOfferSuccess = response => ({
  type: POST_OFFER_SUCCESS,
  payload: response,
})

export const postOfferFail = error => ({
  type: POST_OFFER_FAIL,
  payload: error,
})

export const rejectOffer = (payload, history) => ({
  type: REJECT_OFFER,
  payload: { payload, history },
})

export const rejectOfferSuccess = response => ({
  type: REJECT_OFFER_SUCCESS,
  payload: response,
})

export const rejectOfferFail = error => ({
  type: REJECT_OFFER_FAIL,
  payload: error,
})

export const processOffer = (payload, history) => ({
  type: PROCESS_OFFER,
  payload: { payload, history },
})

export const processOfferSuccess = response => ({
  type: PROCESS_OFFER_SUCCESS,
  payload: response,
})

export const processOfferFail = error => ({
  type: PROCESS_OFFER_FAIL,
  payload: error,
})

export const publishOffer = (payload, history) => ({
  type: PUBLISH_OFFER,
  payload: { payload, history },
})

export const publishOfferSuccess = response => ({
  type: PUBLISH_OFFER_SUCCESS,
  payload: response,
})

export const publishOfferFail = error => ({
  type: PUBLISH_OFFER_FAIL,
  payload: error,
})

export const denyOffer = (payload, history) => ({
  type: DENY_OFFER,
  payload: { payload, history },
})

export const denyOfferSuccess = response => ({
  type: DENY_OFFER_SUCCESS,
  payload: response,
})

export const denyOfferFail = error => ({
  type: DENY_OFFER_FAIL,
  payload: error,
})
